import React from 'react';
import Icon from 'components/icon';
import { string, array, shape } from 'prop-types';

export default function TradeShowTile({ item, viewMoreText, meetUsText }) {
    function linksContainer() {
        if (!item.products.length) { return null; }
        return (
            <div className="links">
                <h5>{meetUsText}</h5>
                {item.products.map(product => (
                    <div key={product.display}><a href="product.url" className="product">{product.display}</a><span>  | </span></div>
                ))}
            </div>
        );
    }

    return (
        <div className="c-base-tile c-listing-tile c-trade-show-tile">
            <div className="tile-content">
                <div className="left">
                    <div className="tile-thumbnail">
                        <img src={item.thumbnail} alt={item.title} />
                    </div>

                    <div className="tile-description">

                        <div className="title">{item.title}</div>
                        {item.excerpt && <p>{item.excerpt}</p>}
                        {linksContainer()}
                    </div>
                </div>
                <div className="tile-details">
                    <div className="date">{item.date}</div>
                    <div className="location">{item.location}</div>
                    <div className="info">{item.venueInfo}</div>
                    <a href={item.tradeShowExternalLink} className="info" target="_blank"><Icon glyph="off-site" /> {viewMoreText}</a>
                    <a href={item.ctaButtonUrl} className="appointment btn-skin-5">{item.ctaButtonText}</a>
                </div>
            </div>
        </div>
    );
}

TradeShowTile.propTypes = {
    /* eslint-disable react/no-typos */
    // The disable is needed until https://github.com/yannickcr/eslint-plugin-react/issues/1389 is resolved
    item: shape({
        thumbnail: string,
        products: array.isRequired,
        title: string.isRequired,
        excerpt: string,
        date: string.isRequired,
        location: string,
        booth: string,
        tradeShowExternalLink: string,
        ctaButtonUrl: string,
        ctaButtonText: string
    }).isRequired,
    viewMoreText: string.isRequired,
    meetUsText: string.isRequired

    /* eslint-enable react/no-typos */
};
